export enum UserTicketDanceRoleTypeEnum {
  LEADER = "LEADER",
  FOLLOWER = "FOLLOWER"
}
